<template>
    <div class="content">
        <div class="leftContent">
            <h1>短信发送</h1>
            <el-form ref="actionFormData" :model="actionFormData" :rules="actionFormDataRules" label-width="120px">
                <el-form-item label="接入号：" prop="receiveIntoNo">
                    <el-input
                    class="intoNoTextareaInSmsMgt"
                    type="textarea"
                    :autosize="{ minRows: 7}"
                    placeholder="请输入接入号，多个连接号请务必以中文分号“；”隔开"
                    v-model.trim="actionFormData.receiveIntoNo"
                    clearable>
                </el-input>
                <p style=" color:#7d7d7d; font-size:12px;">多个连接号请务必以中文分号“；”隔开</p>
            </el-form-item>

            <el-form-item label="接入号文件：">
                <el-upload
                class='upload-div-defind'
                ref="upload"
                action="/"
                :limit="1"
                :before-remove="removeReceiveIntoNo"
                :on-change="importExcel"
                :auto-upload="false">
                    <el-button slot="trigger" style="width: 100%;" plain>导入接入号模板</el-button>
                    <a style="margin-left: 20px; font-size:12px;" href="../../../doc/IntoNumber.xls" download="物联卡接入号模板.xls" >接入号模板下载</a>
                </el-upload>

        </el-form-item>

        <el-form-item label="短信模板：">
            <el-select v-model.trim="smsTemplateContent"  filterable placeholder="请选择或输入关键字" clearable @change="actionFormData.msg = smsTemplateContent">
                <el-option v-for="item in smsTemplate" :value="item.content"  :key="item.id" :label="item.tplName"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="短信内容：" prop="msg">
            <el-input
            type="textarea"
            class="contextTextareaInSmsMgt"
            :autosize="{ minRows: 7}"
            placeholder="请输入内容"
            v-model.trim="actionFormData.msg"
            maxlength="200"
            show-word-limit
            clearable>
        </el-input>
    </el-form-item>


    <el-button class="send-button" type="primary" @click="showConfirmToSendSMSDialog">发 送</el-button>
</el-form>
</div>
<div class="rightContent">
    <h1>发送记录</h1>
    <el-form :inline="true" :model="searchForm"  class="forTbFilter">
        <el-form-item label="发送人：">
            <el-input v-model.trim="searchForm.sendIntoNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="接收人：">
            <el-input v-model.trim="searchForm.receiveIntoNos" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型："> 
            <el-select v-model="searchForm.types" clearable>
                <el-option value="1" label="发送成功"></el-option>
                <el-option value="2" label="接收成功"></el-option>
                <el-option value="3" label="发送失败"></el-option>
                <el-option value="4" label="接收失败"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item class="btnArea">
            <el-button type="primary"  @click="getSmsMgtListHandler">搜索查询</el-button>
            <el-button type="primary"  @click="refresh">刷 新</el-button>
            <el-button type="primary"  @click="exportSms">导 出</el-button>
             <el-button type="primary" @click="showImportApply">Eexcel批量发送</el-button>
        </el-form-item>
    </el-form>
    <el-table :data="tbpg.tableData" border height="611" style="width: 100%">
        <el-table-column type="index" label="序号" width="50px"></el-table-column>
        <el-table-column label="接收人" prop="receiveIntoNo" width="150">
        </el-table-column>
        <el-table-column prop="sendIntoNo" label="发送人" width="150"></el-table-column>
        <el-table-column prop="msg" label="内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" ></el-table-column>
        <el-table-column label="发送时间" width="150">
            <template slot-scope="scope">
                {{formatCreateTime(scope.row.createTime)}}
            </template>
        </el-table-column>
        <el-table-column label="短信状态" width="100">
            <template slot-scope="scope">
                <span v-if="scope.row.sendState == 1" style="color: green;">发送成功</span>
                <span v-else-if="scope.row.sendState == 2" style="color: green;">接收成功</span>
                <span v-else-if="scope.row.sendState == 3" style="color: red;">发送失败</span>
                <span v-else-if="scope.row.sendState == 4" style="color: red;">接收失败</span>
            </template>
        </el-table-column>
    </el-table>  
    <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="tbpg.currentPage"
    :page-sizes="[15, 50, 100, 500]"
    :page-size="tbpg.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="tbpg.total">
</el-pagination>
</div>

<el-dialog
title="提示"
:visible.sync="confirmToSendSMSVisible"
width="30%">
<span >确定要发送短信吗</span>
<span slot="footer" class="dialog-footer">
    <el-button @click="confirmToSendSMSVisible = false">取 消</el-button>
    <el-button type="primary" @click="sendSMSAction">确 定</el-button>
</span>
</el-dialog>  




 <el-dialog
      :append-to-body="true"
      title="导入处理"
      :visible.sync="importVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form :model="dealWithForm" label-width="120px">
        <el-form-item label="导入Excel：" prop="uploadExcel">
          <el-upload
            ref="upload"
            :action="uploadUrl('cmcc/batch/send/sms')"
            :headers="setHeader()"
            :limit="1"
            :auto-upload="false"
            :on-success="handleSuccess"
          >
            <el-button slot="trigger" plain>导入Excel</el-button>
             <el-button style="margin-left: 10px;" plain @click="downPdf()">导入模板</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importCancel">取 消</el-button>
        <el-button type="primary" @click="importApplyHandler">确 定</el-button>
      </div>
    </el-dialog>




</div>
</template>

<script>
import {getSMSList, sendSMS, getSmsTemplateList} from '@/api/sms.js'
import common from '@/utils/common.js'
import XLSX from 'xlsx'
export default {
    data(){   
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles;
            var len = files.length;
            if(len > 0){
                var extName = files[0].name.split('.')[1].toLowerCase();
                if(extName != 'xls' && extName != 'xlsx'){
                    return callback(new Error('请选择要导入的Excel文件'));
                }else{
                    callback();
                }
            }else{
                callback();
            }          
        }     

        return {
            importVisible:false,
            searchForm: {
                sendIntoNo:'',
                receiveIntoNos: '',
                types:'',
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            smsTemplateContent:'',
            smsTemplate: [],//短信模板

            actionFormData:{//短信发送等动作携带的数据对象
                receiveIntoNo: '',
                msg:'',
            },
            actionFormDataRules:{
                receiveIntoNo:[{required: true, message: '请输入连接号', trigger: 'blur'}],
                msg:[{required: true, message: '请输入短信内容', trigger: 'blur'}]
            },
            sendSMSVisible: false,//发送短信编辑框
            confirmToSendSMSVisible: false,  //短信发送确认框
            
        }
    },
    methods: {
          handleSuccess(res) {
      if (res.code == 200) {
        this.importVisible = false;
        this.getSmsMgtListHandler();
        this.$refs.upload.clearFiles();
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
         importApplyHandler() {
      this.$refs.upload.submit();
    },
         downPdf(){
            var link = document.createElement('a');
                link.setAttribute('download', '');
                link.href = '../../../doc/批量发送短信.xls';
                link.click();
        },
         importCancel() {
      this.importVisible = false;
    },
          showImportApply() {
      this.importVisible = true;
    },
        getSmsMgtListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getSMSList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })

            getSmsTemplateList({agentId : localStorage.getItem('id')}).then(res => {
                if(res.data.code == 200){
                    this.smsTemplate = res.data.data.resultList;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },

        refresh(){
            getSMSList({}).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    common.listCallback(this, res, 'tbpg');
                }else{
                    this.$message.error(res.data.message);
                }
                
            })
        },

        showSendSMSDialog(){
            this.sendSMSVisible = true;
        },

        formatCreateTime(createTime){
            console.log(createTime)
            let d = new Date(createTime);
            return this.dateFormat('yyyy-MM-dd hh:mm:ss', d)
        },

        hideSendSMSDialog(){
            this.sendSMSVisible = false;    
            this.$refs.actionFormData.resetFields();  
        },
        showConfirmToSendSMSDialog(){
            this.$refs.actionFormData.validate(valid => {
                if(valid){
                    this.confirmToSendSMSVisible = true;
                }
            });
        },
        sendSMSAction(){
            let data = {
                receiveIntoNo: this.actionFormData.receiveIntoNo.split('；'),
                msg: this.actionFormData.msg,
            }

            sendSMS(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getSmsMgtListHandler();
                }else{
                    this.$message.error(res.data.message);
                }
                this.actionFormData.receiveIntoNo = '';
                this.$refs.upload.clearFiles();
                this.sendSMSVisible = false;
                this.confirmToSendSMSVisible = false;
            })
        },

        removeReceiveIntoNo(){
            this.actionFormData.receiveIntoNo = '';
        },

        importExcel(file) {
            // let file = file.files[0] // 使用传统的input方法需要加上这一步
            var types = file.name.split('.')[1]
            var fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types)
            if (!fileType) {
                this.$message.error('格式错误！请重新选择');
                this.$refs.upload.clearFiles();
                return;
            }
            this.file2Xce(file).then(tabJson => {
                if (tabJson && tabJson.length > 0) {
                    this.xlsxJson = tabJson;
                    console.log('数据', this.xlsxJson);
                    // xlsxJson就是解析出来的json数据,数据格式如下
                    // [
                    //   {
                    //     sheetName: sheet1
                    //     sheet: sheetData
                    //   }
                    // ]

                    let sheetData = this.xlsxJson[0].sheet;
                    if(sheetData.length<1){
                        this.$message.error('空文件！请重新选择');
                        this.$refs.upload.clearFiles();
                        return;
                    }

                    for(var i=0; i<sheetData.length; i++){
                   　　 for(var key in sheetData[i]){
                            this.actionFormData.receiveIntoNo += sheetData[i][key] + '；';
                            console.log("key = "+key+", value = "+sheetData[i][key]); 
                        } 
                    }
               }
            })
        },
        file2Xce(file) {
            return new Promise(function(resolve, reject) {
                var reader = new FileReader()
                reader.onload = function(e) {
                  var data = e.target.result
                  this.wb = XLSX.read(data, {
                    type: 'binary'
                })
                var result = []
                this.wb.SheetNames.forEach((sheetName) => {
                    result.push({
                      sheetName: sheetName,
                      sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
                    })
                })
                resolve(result)
            }
            reader.readAsBinaryString(file.raw)
                // reader.readAsBinaryString(file) // 传统input方法
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getSmsMgtListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getSmsMgtListHandler();
        },
        
        exportSms(){//导出Excel
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
            // data.pageSize = 10000;
            // data.prePageNum = 10000;
            this.exportExcel('/cmcc/sms/download', data);
            this.$message.success('下载中……');
        }
    },

    created () {
        this.getSmsMgtListHandler();
    }
}
</script>

<style lang="scss" scoped>
.content{
    display: flex;
    h1{
        font-size: 14px;
        margin-bottom: 20px;
        background: #409eff;
        color: #fff;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
    }
}
.leftContent{
    flex:1;
    padding-left: 10px;
    padding-right: 20px;
    border-right: 1px solid #eee;
    margin-right: 10px;
    min-width:350px;

    .upload-div-defind{
        >div{
            width: 100% !important;
        }
    }

}




.rightContent{
    flex:3;
    overflow-x: auto;
}

.send-button{
    float: right;
}

</style>
<style>
.intoNoTextareaInSmsMgt > textarea{
    max-height: 250px !important;
}

.contextTextareaInSmsMgt > textarea{
    max-height: 250px !important;
}
</style>
